// Bilingual strings for El Sol Mexican Imports
// Use t("section.key") in components.

export const translations = {
  en: {
    nav: {
      story: "Our Story",
      shop: "Shop",
      specials: "May Specials",
      gallery: "Gallery",
      visit: "Visit",
      contact: "Contact",
      lang_label: "Language",
      switch_to: "Cambiar a Español",
    },

    hero: {
      eyebrow: "Family-owned • Watauga, Texas",
      h_a: "A little piece of",
      h_mexico: "México",
      h_b: "hand-picked",
      h_c: "for your home.",
      sub: "Pottery, talavera, fountains, tin & metal art, rustic and wrought iron and wood benches, sourced from artisans across México and brought to North Texas with care since day one.",
      cta_shop: "Browse What We Sell",
      cta_visit: "Visit the Store",
      stars_note: "Loved by neighbors across the DFW Metroplex",
      open_today: "Open Today",
      open_hours: "10 AM – 6 PM",
      welcome: "¡Bienvenidos!",
      address_short: "5609 E Watauga Rd, TX 76148",
      handmade: "Hecho a mano",
    },

    about: {
      eyebrow: "Our Story",
      h_a: "Rooted in tradition,",
      h_b: "grown in Texas.",
      p1: "For 32 years, El Sol Mexican Imports has been a treasure stop on E Watauga Road — a colorful, ever-changing courtyard packed with authentic finds from artisans across México.",
      p2: "Owner Cristina and Raul Ramon hand-select every piece: hefty terracotta pots, brilliantly glazed talavera, hammered tin sunbursts, rustic wood and wrought-iron furniture, garden saints, and fountains that turn any backyard into a little plaza.",
      p3: "Whether you're styling a patio, refreshing the kitchen, or hunting for a one-of-a-kind gift — we'd love to welcome you. Come browse, chat, and take home a piece with a story.",
      stat_years_k: "32",
      stat_years_v: "Years importing",
      stat_pieces_k: "100s",
      stat_pieces_v: "Pieces in stock",
      stat_family_k: "1",
      stat_family_v: "Family that loves it",
    },

    categories: {
      eyebrow: "What We Sell",
      h_a: "Six aisles of color,",
      h_b: "all under one sun.",
      sub: "Every category is rotating constantly — what's here this week may be gone next week. Stop by often, or call us to ask if we have a specific piece.",
      in_store: "In store now",
      pottery_t: "Pottery & Talavera",
      pottery_b: "We carry a wide variety and sizes of hand-painted talavera vases, planters, sinks, and dinnerware with rich cobalt, gold, and floral motifs.",
      metal_t: "Tin & Metal Art",
      metal_b: "Sun faces, agaves, cacti, and bluebonnets cut and painted from steel — built to weather and brighten.",
      statuary_t: "Statuary & Fountains",
      statuary_b: "Concrete saints, animals, birdbaths, and tiered fountains for the courtyard, patio, or front yard.",
      rustic_t: "Rustic Furniture",
      rustic_b: "Solid wood tables, benches, chairs, and consoles with warm patinas and old-world character.",
      iron_t: "Iron Furniture",
      iron_b: "Wrought-iron bistros, plant stands, and entry pieces hand-forged in classic colonial silhouettes.",
      wall_t: "Wall Art",
      wall_b: "Tin sunbursts, talavera plates, hammered crosses, painted carvings — color for any wall in the house.",
    },

    specials: {
      eyebrow: "This month at El Sol",
      h_a: "May",
      h_b: "Specials",
      sub: "In-store only. Limited quantities — when they're gone, they're gone. Stop by 5609 E Watauga Rd or give Raul a call.",
      cta_call: "Ask about a piece",
      featured_label: "Featured Special · #1",
      featured_extra: "From small herb pots to statement urns — everything outdoor is marked down for May.",
      featured_supplies: "In-store only · while supplies last",
      in_store: "In-store only",
      footnote: "Prices and availability subject to change · Specials valid through May",
      offer_badge: "¡Oferta!",
      i1_t: "All Outdoor Pottery",
      i1_b: "Large planters, urns & terracotta",
      i1_d: "15% OFF",
      i2_t: "Wall Hangings",
      i2_b: "Tin sunbursts, talavera plates, longhorns & more",
      i2_d: "20% OFF",
      i3_t: "Assorted Bird Baths",
      i3_b: "Hand-painted talavera & ceramic",
      i3_d: "$25 OFF",
      i4_t: "Medium Size Planters",
      i4_b: "Stacked talavera in cobalt, green & multicolor",
      i4_d: "10% OFF",
      i5_t: "Ceramic Art",
      i5_b: "While they last — picture tiles & decorative pieces",
      i5_d: "10% OFF",
    },

    gallery: {
      eyebrow: "Snapshots from the courtyard",
      h_a: "A peek at our",
      h_b: "colorful",
      h_c: "corner of Texas.",
      fb_link: "See more on Facebook",
      cap_garden: "Garden Statuary",
      cap_talavera: "Talavera",
      cap_metal: "Metal Art",
      pasale: "¡Pásale!",
      pasale_sub: "Step inside the courtyard at 5609 E Watauga Rd.",
    },

    visit: {
      eyebrow: "Come visit",
      h_a: "We're easy to find,",
      h_b: "hard to leave.",
      address_label: "Address",
      address_value: "5609 E Watauga Rd, Watauga, TX 76148",
      phone_label: "Call Raul",
      phone_value: "(817) 656-1046",
      email_label: "Email",
      email_value: "elsolraul@yahoo.com",
      hours_title: "Store Hours",
      open_today: "Open today",
      today_suffix: " · today",
      day_mon: "Monday",
      day_tue: "Tuesday",
      day_wed: "Wednesday",
      day_thu: "Thursday",
      day_fri: "Friday",
      day_sat: "Saturday",
      day_sun: "Sunday",
      t_weekday: "10 AM – 6 PM",
      t_sun: "1 PM – 4 PM",
      map_title: "El Sol Mexican Imports — Map",
    },

    contact: {
      eyebrow: "Say hola",
      h_a: "Looking for",
      h_b: "something",
      h_c: "special?",
      sub: "Tell us what you're after — a fountain for the patio, a talavera sink, a dining table for ten — and we'll let you know what we have (or can find).",
      l_name: "Your name *",
      l_email: "Email *",
      l_phone: "Phone",
      l_subject: "Looking for",
      l_message: "Your message *",
      ph_name: "María González",
      ph_email: "you@example.com",
      ph_phone: "(optional)",
      ph_subject: "e.g. Tiered fountain, large agave, talavera sink",
      ph_message: "Tell us a bit about what you're after — sizes, colors, where it'll go…",
      privacy: "We'll never share your info. Reply usually within 1–2 days.",
      btn_send: "Send Message",
      btn_sending: "Sending…",
      ok: "¡Gracias! We received your note and will be in touch soon.",
      err_empty: "Please fill in your name, email, and a short message.",
      err_fail: "Couldn't send right now — please call (817) 656-1046.",
    },

    footer: {
      tagline: "Authentic Mexican pottery, talavera, garden art, statuary, and hand-built furniture — proudly serving North Texas from a sunny corner of Watauga.",
      visit: "Visit",
      contact: "Contact",
      follow: "Follow",
      directions: "Get directions →",
      facebook: "Facebook",
      copyright: "All rights reserved.",
      thanks: "¡Gracias por visitarnos!",
    },
  },

  es: {
    nav: {
      story: "Nuestra Historia",
      shop: "Tienda",
      specials: "Ofertas de Mayo",
      gallery: "Galería",
      visit: "Visítanos",
      contact: "Contacto",
      lang_label: "Idioma",
      switch_to: "Switch to English",
    },

    hero: {
      eyebrow: "Negocio familiar • Watauga, Texas",
      h_a: "Un pedacito de",
      h_mexico: "México",
      h_b: "elegido a mano",
      h_c: "para tu hogar.",
      sub: "Cerámica, talavera, fuentes, arte en hojalata y metal, bancas rústicas de hierro forjado y madera, traídas de artesanos de todo México al norte de Texas con cariño desde el primer día.",
      cta_shop: "Conoce Nuestros Productos",
      cta_visit: "Visita la Tienda",
      stars_note: "Querido por vecinos en todo el área metropolitana de DFW",
      open_today: "Abierto Hoy",
      open_hours: "10 AM – 6 PM",
      welcome: "¡Bienvenidos!",
      address_short: "5609 E Watauga Rd, TX 76148",
      handmade: "Hecho a mano",
    },

    about: {
      eyebrow: "Nuestra Historia",
      h_a: "Con raíces en la tradición,",
      h_b: "florecemos en Texas.",
      p1: "Por 32 años, El Sol Mexican Imports ha sido una parada llena de tesoros en E Watauga Road — un patio colorido y siempre cambiante, repleto de hallazgos auténticos de artesanos de todo México.",
      p2: "Los dueños, Cristina y Raúl Ramón, eligen cada pieza personalmente: macetas robustas de terracota, talavera con esmaltes brillantes, soles de hojalata martillada, muebles rústicos de madera y hierro forjado, santos para el jardín, y fuentes que convierten cualquier patio en una pequeña plaza.",
      p3: "Ya sea que estés decorando el patio, renovando la cocina, o buscando un regalo único — nos encantaría darte la bienvenida. Ven, mira, charla, y llévate a casa una pieza con historia.",
      stat_years_k: "32",
      stat_years_v: "Años importando",
      stat_pieces_k: "Cientos",
      stat_pieces_v: "Piezas disponibles",
      stat_family_k: "1",
      stat_family_v: "Familia que lo ama",
    },

    categories: {
      eyebrow: "Lo Que Vendemos",
      h_a: "Seis pasillos de color,",
      h_b: "todos bajo un mismo sol.",
      sub: "Cada categoría cambia constantemente — lo que está esta semana puede no estar la próxima. Visítanos seguido o llámanos para preguntar si tenemos una pieza específica.",
      in_store: "Disponible en tienda",
      pottery_t: "Cerámica y Talavera",
      pottery_b: "Tenemos una gran variedad de tamaños de floreros, macetas, lavabos y vajilla de talavera pintados a mano con motivos florales en cobalto, dorado y más.",
      metal_t: "Arte en Hojalata y Metal",
      metal_b: "Soles, agaves, cactus y bluebonnets cortados y pintados en acero — hechos para resistir y alegrar.",
      statuary_t: "Estatuaria y Fuentes",
      statuary_b: "Santos, animales, bebederos y fuentes de varios niveles en concreto para el patio, el porche o el jardín delantero.",
      rustic_t: "Muebles Rústicos",
      rustic_b: "Mesas, bancas, sillas y consolas de madera sólida con pátinas cálidas y carácter del viejo mundo.",
      iron_t: "Muebles de Hierro",
      iron_b: "Mesas bistró, pedestales y piezas de entrada en hierro forjado a mano con siluetas coloniales clásicas.",
      wall_t: "Arte de Pared",
      wall_b: "Soles de hojalata, platos de talavera, cruces martilladas, tallas pintadas — color para cualquier pared de la casa.",
    },

    specials: {
      eyebrow: "Este mes en El Sol",
      h_a: "Ofertas de",
      h_b: "Mayo",
      sub: "Solo en tienda. Cantidades limitadas — cuando se acaban, se acaban. Visítanos en 5609 E Watauga Rd o llama a Raúl.",
      cta_call: "Pregunta por una pieza",
      featured_label: "Oferta Destacada · #1",
      featured_extra: "Desde macetas pequeñas para hierbas hasta jarrones grandes — todo lo de exterior está rebajado en mayo.",
      featured_supplies: "Solo en tienda · hasta agotar existencias",
      in_store: "Solo en tienda",
      footnote: "Precios y disponibilidad sujetos a cambio · Ofertas válidas durante mayo",
      offer_badge: "¡Oferta!",
      i1_t: "Toda la Cerámica de Exterior",
      i1_b: "Macetas grandes, jarrones y terracota",
      i1_d: "15% DESC.",
      i2_t: "Decoración de Pared",
      i2_b: "Soles de hojalata, platos de talavera, longhorns y más",
      i2_d: "20% DESC.",
      i3_t: "Bebederos Variados",
      i3_b: "Talavera y cerámica pintada a mano",
      i3_d: "$25 DESC.",
      i4_t: "Macetas Medianas",
      i4_b: "Talavera apilada en cobalto, verde y multicolor",
      i4_d: "10% DESC.",
      i5_t: "Arte en Cerámica",
      i5_b: "Mientras duren — azulejos decorativos y piezas únicas",
      i5_d: "10% DESC.",
    },

    gallery: {
      eyebrow: "Postales del patio",
      h_a: "Un vistazo a nuestro",
      h_b: "colorido",
      h_c: "rincón de Texas.",
      fb_link: "Ver más en Facebook",
      cap_garden: "Estatuaria de Jardín",
      cap_talavera: "Talavera",
      cap_metal: "Arte en Metal",
      pasale: "¡Pásale!",
      pasale_sub: "Entra al patio en 5609 E Watauga Rd.",
    },

    visit: {
      eyebrow: "Ven a visitarnos",
      h_a: "Fáciles de encontrar,",
      h_b: "difíciles de dejar.",
      address_label: "Dirección",
      address_value: "5609 E Watauga Rd, Watauga, TX 76148",
      phone_label: "Llama a Raúl",
      phone_value: "(817) 656-1046",
      email_label: "Correo",
      email_value: "elsolraul@yahoo.com",
      hours_title: "Horario de la Tienda",
      open_today: "Abierto hoy",
      today_suffix: " · hoy",
      day_mon: "Lunes",
      day_tue: "Martes",
      day_wed: "Miércoles",
      day_thu: "Jueves",
      day_fri: "Viernes",
      day_sat: "Sábado",
      day_sun: "Domingo",
      t_weekday: "10 AM – 6 PM",
      t_sun: "1 PM – 4 PM",
      map_title: "El Sol Mexican Imports — Mapa",
    },

    contact: {
      eyebrow: "Salúdanos",
      h_a: "¿Buscas",
      h_b: "algo",
      h_c: "especial?",
      sub: "Cuéntanos qué buscas — una fuente para el patio, un lavabo de talavera, una mesa para diez — y te diremos qué tenemos (o qué podemos conseguir).",
      l_name: "Tu nombre *",
      l_email: "Correo *",
      l_phone: "Teléfono",
      l_subject: "Lo que buscas",
      l_message: "Tu mensaje *",
      ph_name: "María González",
      ph_email: "tu@ejemplo.com",
      ph_phone: "(opcional)",
      ph_subject: "ej. Fuente de niveles, agave grande, lavabo de talavera",
      ph_message: "Cuéntanos un poco sobre lo que buscas — tamaños, colores, dónde irá…",
      privacy: "Nunca compartiremos tu información. Respondemos en 1–2 días.",
      btn_send: "Enviar Mensaje",
      btn_sending: "Enviando…",
      ok: "¡Gracias! Recibimos tu mensaje y te contactaremos pronto.",
      err_empty: "Por favor completa tu nombre, correo y un mensaje breve.",
      err_fail: "No pudimos enviar ahora — por favor llama al (817) 656-1046.",
    },

    footer: {
      tagline: "Cerámica mexicana auténtica, talavera, arte de jardín, estatuaria y muebles hechos a mano — sirviendo con orgullo al norte de Texas desde un rinconcito soleado de Watauga.",
      visit: "Visítanos",
      contact: "Contacto",
      follow: "Síguenos",
      directions: "Cómo llegar →",
      facebook: "Facebook",
      copyright: "Todos los derechos reservados.",
      thanks: "¡Gracias por visitarnos!",
    },
  },
};
